"use strict";
import "../formatters/general";
import FactorBrokersService from "./factor_brokers_service";
import TypeAhead from "./ui/type_ahead";
export default React.createClass({
  search: function(term) {
    return FactorBrokersService.search(term, this.props.silo);
  },
  componentDidMount() {
    if (this.props.autoFocus) {
      const element = ReactDOM.findDOMNode(this);
      window.setTimeout(() => {
        element.focus();
        element.select();
      });
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      TypeAhead,
      {
        readOnly: this.props.readOnly,
        remoteSearch: this.search,
        display: this.debtorDisplay,
        placeHolder: "Debtor Name",
        className: "carrier-setter__typeahead",
        isDroppable: true,
        selectedItem: this.props.factorBroker,
        onSelectItem: this.props.onSelectDebtor,
        onClearSelectedItem: this.props.onClearDebtor,
        onFocus: this.selectAll
      }
    );
  },
  debtorDisplay: function(debtor) {
    let html = debtor.name;
    const address = debtor.payment_address;
    const phone = debtor.external_data["Phone1"] || debtor.external_data["Phone2"];
    const dot = debtor.external_data["DotNo"];
    const mc = debtor.external_data["MotorCarrNo"];
    if (dot && mc) {
      html += "<br> DOT: " + dot + " MC: " + mc;
    } else if (dot) {
      html += "<br> DOT: " + dot;
    } else if (mc) {
      html += "<br> MC: " + mc;
    }
    if (phone) {
      html += "<br>" + phone;
    }
    if (address) {
      html += "<br>";
      if (address.address_line_1) {
        html += address.address_line_1 + " ";
      }
      if (address.city) {
        html += address.city;
        if (address.state) {
          html += ", " + address.state;
        }
      }
    }
    return html;
  },
  selectAll(event) {
    event.target.select();
  }
});
